module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/3_0-5d9916d843d749987fe3add380a28d4c.png";